import React, { useState, useEffect } from "react";
import AddProductToSale from "./AddProductToSale";
import {
  GetProductList,
  UpdateProductToSalePost,
} from "../../../server/SalesManagement";
import { setPreload } from "../../../server/CartsOpen";
import showAlert from "../../../server/ShowAlert";
import { useDispatch } from "react-redux";

const ProductInSale = ({ sale, checkedDates }) => {
  const dispatch = useDispatch();
  const [product, setProduct] = useState(false);
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    getProductList();
  }, [sale]);

  const getProductList = () => {
    const initialProducts = sale?.targetProducts || [];
    setProductList(initialProducts);
  };

  const updateProduct = (gtin, Add) => {
    const data = {
      SaleId: sale?.promoId || sale?.Id,
      ProductMkt: gtin,
      Add,
    };

    const isAlreadyInList = (productList || []).some(
      (item) => item.gtin === gtin || item.ProductMkt === gtin,
    );

    if (isAlreadyInList && Add) {
      showAlert({ msgTitle: "המוצר כבר נמצא במבצע", msgType: "error" });
      return;
    }

    const from = sale?.FromDate || sale?.startDate;
    const to = sale?.ToDate || sale?.endDate;

    if (checkedDates(from, to)) {
      dispatch(setPreload(true));
      UpdateProductToSalePost(data)
        .then((x) => {
          let productArr = [...(productList || [])];

          if (x.data && Add) {
            if (x.data[0] && !x.data[0].Id && x.data[0].Massage) {
              showAlert({ msgTitle: x.data[0].Massage });
              return;
            }

            productArr.push(x.data[0] || x.data);
            setProductList(productArr);
            setProduct(false);
            showAlert({ msgTitle: "המוצר התווסף בהצלחה", msgType: "success" });
          } else if (!Add) {
            const newList = productArr.filter(
              (item) => item.gtin !== gtin && item.ProductMkt !== gtin,
            );
            setProductList(newList);
            showAlert({
              msgTitle: "המוצר נמחק מהמבצע בהצלחה",
              msgType: "success",
            });
          }
        })
        .catch((err) => {
          const errMsg = err.response?.data || "שגיאת תקשורת";
          showAlert({ msgTitle: errMsg, msgType: "error" });
          setProduct(false);
        })
        .finally(() => dispatch(setPreload(false)));
    } else {
      showAlert({
        msgTitle: "המבצע כבר התחיל, לא ניתן לשנות הגדרות",
        msgType: "warning",
      });
    }
  };

  return (
    <div className="show-product-table">
      {product ? (
        <AddProductToSale updateProduct={updateProduct} />
      ) : (
        <button className="add-product" onClick={() => setProduct(true)}>
          הוספת מוצר למבצע
        </button>
      )}

      {productList?.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>מק״ט</th>
              <th>מחיקת מוצר</th>
            </tr>
          </thead>
          <tbody>
            {productList.map((x, index) => (
              <tr key={x.promoId || x.gtin || index}>
                <td>{x.gtin || x.ProductMkt}</td>
                <td>
                  <button
                    className="btn-delete"
                    onClick={() => updateProduct(x.gtin || x.ProductMkt, false)}
                  >
                    מחק
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="no-products">
          <h2>אין רשימת מוצרים</h2>
        </div>
      )}
    </div>
  );
};

export default ProductInSale;
